module.exports = __webpack_public_path__ + "78ae1fc2f4ce172f64a9701796e4833c.svg";